import { createFileRoute } from "@tanstack/react-router"
import { OrganizationsListPage } from "@/pages/organizations-list"

export const Route = createFileRoute("/organizations")({
	component: OrganizationsListPage,
})
